<div class="card-container flex">
  <div class="card spacing--margin-all">
    <agr-summary-card title="{{ 'discount-setting.title' | translate }}" [canExpand]="false">
      <tr class="spacing--padding-all spacing--margin-left">
        <td>{{ 'discount-setting.memberDiscountNL' | translate }}</td>
        <td>
          <mat-form-field class="spacing--margin-left mat-width">
            <input matInput [formControl]="formGroup.controls.memberDiscountNL" type="number" />
          </mat-form-field>
        </td>
      </tr>
      <tr class="spacing--padding-all spacing--margin-left">
        <td>{{ 'discount-setting.memberBenefitNL' | translate }}</td>
        <td>
          <mat-form-field class="spacing--margin-left mat-width">
            <input matInput [formControl]="formGroup.controls.memberBenefitNL" type="number" />
          </mat-form-field>
        </td>
      </tr>
      <tr class="spacing--padding-all spacing--margin-left">
        <td>{{ 'discount-setting.memberBenefitAbroad' | translate }}</td>
        <td>
          <mat-form-field class="spacing--margin-left mat-width">
            <input matInput [formControl]="formGroup.controls.memberBenefitAbroad" type="number" />
          </mat-form-field>
        </td>
      </tr>
      <agr-extended-notification
        notificationType="warning"
        [title]="'discount-setting.warning-title' | translate"
        [message]="'discount-setting.warning-message' | translate"
      >
      </agr-extended-notification>
    </agr-summary-card>
  </div>
</div>
